export default __webpack_public_path__ + "static/media/lightmode.fc44cc41.png";